export enum Plans {
  free = "subscription",
  basic = "subscription_monthly_basic",
  basic_promo = "rc_promo_basic_lifetime",
  premium = "subscription_monthly_premium",
  premium_promo = "rc_promo_premium_lifetime"
}

const PlanAliases: Record<string, Plans> = {
  "subscription_monthly_basic:smb": Plans.basic,
  "subscription_monthly_premium:smp": Plans.premium,
};

export function getPlan(value: string): Plans | undefined {
  return (Object.values(Plans) as string[]).includes(value)
    ? (value as Plans)
    : PlanAliases[value];
}
